import React, { useEffect, useState } from 'react';
import { cmsList } from '../../api/apiHandler';
import { Loading } from '../../components/loading/loading';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import '../../i18';

const TnC = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [content, setContent] = useState(null);
    const isBlankLayout = location.pathname === '/app-tandc';

    useEffect(() => {
        const fetchTnC = async () => {
            try {
                setIsLoading(true);
                const response = await cmsList();
                const TnCContent = response.data.find(page => page.tag_name === "Terms & Condition");
                setContent(TnCContent);
            } catch (error) {
                console.error('Error fetching TnC:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTnC();
    }, []);

    if (isLoading) {
        return <Loading />;
    }

    if (!content) {
        return <div>{t('noContent')}</div>;
    }

    if (isBlankLayout) {
        return (
            <div className="course-single-area pd-bottom-90">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="PageTitleBox">
                                <h2 className="PageTitleHeading">{t('TnC')}</h2>
                            </div>
                        </div>
                    </div>
                    <div className='row justify-content-center' dangerouslySetInnerHTML={{ __html: content.content }} />
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="PageTitleBox">
                                <h2 className="PageTitleHeading">{t('TnC')}</h2>
                            </div>
                        </div>
                    </div>
                    <div className='row justify-content-center' dangerouslySetInnerHTML={{ __html: content.content }} />
                </div>
            </div>
        </>
    );
}

export default TnC;